import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=d8c2e2de&"
import script from "./TreeItem.ts?vue&type=script&lang=ts&"
export * from "./TreeItem.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TreeItem.vue"
export default component.exports